import { Overrides } from '../../types';
import colors from '../colors';

export const formControlLabelOverrides: Overrides = {
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        marginLeft: 0,
        marginRight: 0,
        '&.LeftInput .MuiFormControlLabel-label': {
          marginLeft: '6px',
        },

        '&.FDBCheckboxField': {
          alignItems: 'start',

          '& .FDBCheckbox': {
            marginTop: '-3.5px',
            flexShrink: 0,
          },
        },
      },
      label: {
        color: colors.mono900,
        // Override MUI's default styles when it renders an asterisk for required fields
        display: 'flex',
        flexDirection: 'column',
      },
      asterisk: {
        // Hide MUI's built-in asterisk when required prop is true
        display: 'none',
      },
    },
  },
};
